(function () {
  function loadConsentAPI(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback();
      return;
    }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) callback();
      }
    );
  }

  /* Le visiteur a-t-il DEJA pris une decision ?
     currentVisitorConsent() renvoie 'yes' / 'no' quand la decision est prise,
     et une chaine vide sinon. C'est la seule methode officielle qui repond a
     cette question : shouldShowBanner() ne verifie que la region (voir la note
     de la documentation Shopify), il ne suffit donc pas a lui seul.
     sale_of_data est volontairement exclu : il peut etre pose automatiquement
     par le signal GPC sans decision du visiteur sur les cookies. */
  function consentAlreadyGiven() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
    var consent = cp.currentVisitorConsent() || {};
    return ['analytics', 'marketing', 'preferences'].some(function (key) {
      return consent[key] === 'yes' || consent[key] === 'no';
    });
  }

  /* Enregistre le consentement via l'API officielle Shopify.
     Le masquage visuel du bandeau est fait AVANT (au clic) et ne depend
     jamais du reseau : l'enregistrement se fait ici, meme si l'API
     n'etait pas encore chargee au moment du clic.
     Une erreur d'enregistrement declenche une seule nouvelle tentative :
     sans enregistrement, la decision serait perdue au changement de page. */
  function recordConsent(granted, attempt) {
    loadConsentAPI(function () {
      window.Shopify.customerPrivacy.setTrackingConsent(
        { analytics: granted, marketing: granted, preferences: granted },
        function (result) {
          if (result && result.error && !attempt) recordConsent(granted, 1);
        }
      );
    });
  }

  /* onShown : appele une fois la classe posee (le bandeau ferme est en
     visibility: hidden, donc non focusable avant). */
  function showBanner(banner, onShown) {
    window.requestAnimationFrame(() => {
      banner.classList.add('is-visible');
      if (onShown) onShown();
    });
  }

  function hideBanner(banner) {
    banner.classList.remove('is-visible');
  }

  document.addEventListener('DOMContentLoaded', () => {
    const banner = document.getElementById('tpCookieBanner');
    if (!banner) return;

    const acceptBtn = document.getElementById('tpCookieAcceptBtn');
    const rejectBtn = document.getElementById('tpCookieRejectBtn');

    loadConsentAPI(() => {
      /* Deux conditions, dans cet ordre :
         1. le visiteur n'a pas encore decide (currentVisitorConsent) ;
         2. sa region demande une banniere (shouldShowBanner).
         L'ancienne version ne testait que la seconde : la region etant
         toujours vraie, le bandeau revenait a chaque changement de page
         malgre un consentement deja enregistre. */
      if (consentAlreadyGiven()) return;
      if (window.Shopify.customerPrivacy.shouldShowBanner()) {
        showBanner(banner);
      }
    });

    /* Si le consentement est enregistre par une autre surface (autre onglet,
       modale Shopify), on masque le bandeau sans attendre un rechargement. */
    document.addEventListener('visitorConsentCollected', () => hideBanner(banner));

    /* Declencheurs "Preferences en matiere de cookies" (ex. footer) :
       reveles uniquement quand le bandeau existe, puis rouvrent le bandeau
       pour permettre de modifier le consentement a tout moment. */
    const prefTriggers = document.querySelectorAll('[data-open-cookie-preferences]');
    prefTriggers.forEach((trigger) => { trigger.hidden = false; });
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-open-cookie-preferences]');
      if (!trigger) return;
      loadConsentAPI(() => {
        showBanner(banner, () => acceptBtn.focus());
      });
    });

    acceptBtn.addEventListener('click', () => {
      hideBanner(banner);
      recordConsent(true);
    });

    rejectBtn.addEventListener('click', () => {
      hideBanner(banner);
      recordConsent(false);
    });
  });
})();
